<template>
	<details class="c-mcp-tool-list" :open="!collapsed">
		<summary>Available MCP tools ({{ tools.length }})</summary>
		<ul>
			<li v-for="tool in tools" :key="tool.name">
				<code>{{ tool.name }}</code>
				<p>{{ tool.description }}</p>
			</li>
		</ul>
	</details>
</template>

<script>
export default {
	name: 'McpToolList',
	props: {
		collapsed: {
			type: Boolean,
			default: true,
		},
	},
	data: function () {
		return {
			// Keep names and descriptions in sync with backend/components/mcp/server.js.
			tools: [
				{
					name: 'library_list_ads',
					description:
						'Search, filter, sort, and preview saved ads in your library.',
				},
				{
					name: 'library_get_ad',
					description:
						'Get full details and a preview of one saved ad by ad ID.',
				},
				{
					name: 'boards_list',
					description: 'List workspace boards and their public link slugs.',
				},
				{ name: 'folders_list', description: 'List workspace folders.' },
				{
					name: 'trackers_list',
					description: 'List brand trackers in your workspace.',
				},
				{
					name: 'tracker_list_ads',
					description: 'Search and filter ads from one tracked brand.',
				},
				{
					name: 'ad_save',
					description:
						'Save an existing ad block to your library, optionally adding it to boards.',
				},
				{
					name: 'ad_save_from_url',
					description:
						'Save an ad from a supported Facebook, Instagram, TikTok, or LinkedIn URL.',
				},
				{
					name: 'board_create',
					description:
						'Create a workspace board, optionally in a chosen folder.',
				},
				{ name: 'folder_create', description: 'Create a workspace folder.' },
				{
					name: 'ad_update',
					description: 'Update tags and board assignments for a saved ad.',
				},
				{
					name: 'multiplayer_list_ads',
					description: 'Search, filter, sort, and preview Multiplayer ads.',
				},
				{ name: 'usage_get', description: 'Get your workspace usage summary.' },
				{
					name: 'ai_generation_list',
					description:
						'List previous AI generations with their results and status.',
				},
			],
		};
	},
};
</script>

<style lang="scss">
.c-mcp-tool-list {
	margin: var(--spacer-sm) 0;
	border: 1px solid var(--color-bg-5);
	border-radius: 0.5rem;
	background-color: var(--color-bg-1);

	summary {
		padding: var(--margin-lg);
		font-weight: 600;
		cursor: pointer;
	}

	ul {
		list-style: none;
		margin: 0;
		padding: 0 var(--margin-lg) var(--margin-lg);
	}

	li {
		padding: var(--margin) 0;

		&:before {
			content: none;
		}

		& + li {
			border-top: 1px solid var(--color-bg-5);
		}
	}

	code {
		font-size: var(--font-size-sm);
	}

	p {
		margin: 0.25rem 0 0;
		font-size: var(--font-size-sm);
	}
}
</style>
